import { HolidayTripsListApi, HolidayTripsQueryFilter, HolidayTripsQueryRecord, HolidayTripsQueryType } from 'api/holiday-trips-list';
import { autoinject } from "aurelia-framework";
import { QueryParams } from 'model/essential-types';
import { HolidayTripListQueryDTO, HolidayTripsClient } from "api/swagger/ApiClient";
import { BusinessKeywordsMapping } from "api/client/mapping/business-keywords-mapping";
import { EssentialTypesMapping } from "api/client/mapping/essential-types-mapping";
import { HelpersMapping } from 'api/client/mapping/helpers-mapping';

@autoinject
export class HolidayTripsListClientApi implements HolidayTripsListApi {
  constructor(private holidayTripsClient: HolidayTripsClient, private helpersMapping: HelpersMapping, private businessKeywordsMapping: BusinessKeywordsMapping, private essentialTypesMapping: EssentialTypesMapping) { }

  async queryHolidayTrips(type: HolidayTripsQueryType, filter: HolidayTripsQueryFilter, params: QueryParams): Promise<HolidayTripsQueryRecord[]> {
    switch (type) {
      case HolidayTripsQueryType.Current: {
        return (await this.holidayTripsClient.getFutureForCurrentUser(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapToHolidayTripsQueryRecord(x));
      }
      case HolidayTripsQueryType.Past: {
        return (await this.holidayTripsClient.getPastForCurrentUser(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapToHolidayTripsQueryRecord(x));
      }
      case HolidayTripsQueryType.All: {
        return (await this.holidayTripsClient.getAllForAdministrator(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapToHolidayTripsQueryRecord(x));
      }
    }
  }

  private mapToHolidayTripsQueryRecord(dto: HolidayTripListQueryDTO): HolidayTripsQueryRecord {
    return {
      id: dto.id,
      name: dto.name,
      from: dto.startDate,
      to: dto.endDate,
      countries: dto.countries.map(c => this.businessKeywordsMapping.mapToCountry(c)),
      travelers: dto.travellers.map(t => this.essentialTypesMapping.mapSystemUserInfoToUserInfo(t)),
      isActive: dto.isActive
    }
  }
}
